import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import SearchIcon from "@mui/icons-material/Search";
import sear from "../../images/search.svg";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  Box,
  Chip,
  Collapse,
  List,
  ListItemButton,
  Skeleton,
} from "@mui/material";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { sortByFn } from "../../Services/SortBy";
import { useNavigate } from "react-router-dom";
import { mostViewedProductsFn } from "../../Services/MostViewedProducts";
import { Close } from "@mui/icons-material";
import { mostPopularCategoriesFn } from "../../Services/MostPopularCategories";

const SearchPage = ({ from, setClose }) => {
  const [open, setOpen] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [products, setProducts] = useState([]);
  const [chip, setChip] = useState(null);

  const { mutate: onSearch, isLoading } = useMutation(sortByFn, {
    onSuccess: (res) => {
      setProducts(res.data.data.product_list);
    },
  });

  const handleSearch = (event) => {
    setChip(null);
    event.target.value?.length !== 0 ? setCollapse(true) : setCollapse(false);
    onSearch({ search: event.target.value });
  };

  useEffect(
    () => {
      if (chip) {
        setCollapse(true);
        onSearch({ search: chip });
      } else {
        setCollapse(false);
      }
    },
    // eslint-disable-next-line
    [chip]
  );

  const navigate = useNavigate();
  const { data: mostViewedProducts } = useQuery(
    ["mostViewedProducts"],
    () => mostViewedProductsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: popularCategories } = useQuery(
    ["popularCategories"],
    mostPopularCategoriesFn,
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return (
    <>
      {from === "Mobile" ? (
        <ListItemButton className="!rounded" onClick={() => setOpen(true)}>
          <span className="flex gap-5 items-center">
            <SearchIcon className="!text-purple-600" />
            Search Products
          </span>
        </ListItemButton>
      ) : (
        <div className="com9" onClick={() => setOpen(true)}>
          <div className="comm">
            <label for="search">
              <div class="comm1">
                <img src={sear} alt="" class="comm2" />
              </div>
              <input
                type="text"
                placeholder="Search"
                name="search"
                class="comm3"
                value=""
              />
            </label>
          </div>
        </div>
      )}

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box className="absolute outline-none rounded-sm -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 lg:p-5 p-3 py-5 bg-white w-[99%] lg:w-2/3 lg:h-5/6 h-[99%] overflow-y-auto">
          <span className="flex justify-end">
            <Close
              className="!absolute !text-3xl right-2 top-2"
              onClick={() => {
                setOpen(false);
                setClose(false);
              }}
            />
          </span>
          <div className="flex mt-6 gap-2 items-center border rounded px-2">
            <input
              placeholder="Search for products, brands and more"
              className="w-full outline-none p-2"
              onChange={(event) => handleSearch(event)}
            />
            <SearchIcon className="text-gray-500" />
          </div>
          <Collapse in={collapse}>
            {isLoading ? (
              <List className="!h-72 shadow !overflow-y-auto border">
                {products?.map((product, index) => {
                  return (
                    <ListItemButton key={index + 1} className="!flex !gap-2">
                      <Skeleton className="!h-10 !w-10 !scale-100" />
                      <Skeleton className="lg:w-1/3 w-11/12 !h-7" />
                    </ListItemButton>
                  );
                })}
              </List>
            ) : (
              <List className="!h-72 shadow !overflow-y-auto border !p-1">
                {products?.map((product) => {
                  return (
                    <ListItemButton
                      key={product.id}
                      className="!flex !gap-2 hover:!bg-primary !rounded hover:!text-white"
                      onClick={() => {
                        navigate(`/product/${product.id}/${product.slug}`);
                        setOpen(false);
                        setClose(false);
                      }}
                    >
                      <img
                        alt=""
                        src={product.variant_image}
                        className="h-10 rounded"
                      />
                      {product.variant_name}
                    </ListItemButton>
                  );
                })}
              </List>
            )}
          </Collapse>

          <div className="flex lg:flex-row flex-col mt-5">
            <div className="lg:w-7/12 w-full lg:border-r lg:pr-6">
              <p className="py-2 lg:text-lg font-semibold">Trending Searches</p>
              <div className="flex gap-2 overflow-x-auto hide-scroll">
                {["window", "ecommerce", "hosting", "hatchling", "prohost"].map(
                  (i, index) => {
                    return (
                      <Chip
                        key={i.index + 1}
                        icon={<TrendingUpIcon />}
                        label={i}
                        onClick={() => setChip(i)}
                        variant={chip === i ? "contained" : "outlined"}
                        className="!rounded"
                        onDelete={() => chip === i && setChip(null)}
                        deleteIcon={<Close />}
                      />
                    );
                  }
                )}
              </div>
              <p className="py-2 lg:text-lg font-semibold">Popular Products</p>
              {mostViewedProducts?.data?.data?.product_list
                ?.slice(0, 5)
                ?.map((item) => (
                  <div
                    key={item.id}
                    className="flex gap-2 mt-2 items-center p-2 bg-gray-100 hover:bg-gray-200 lg:cursor-pointer rounded-md"
                    onClick={() => {
                      navigate(`/product/${item.id}/${item.slug}`);
                      setOpen(false);
                      setClose(false);
                    }}
                  >
                    <img
                      src={item.variant_image}
                      alt=""
                      className="w-14 rounded-md"
                    />
                    <span className="flex flex-col gap-1">
                      <p className="font-semibold truncate w-[258px] lg:text-base text-sm">
                        {item.variant_name}
                      </p>
                      <p className="lg:text-sm text-xs">{item.brand_name}</p>
                    </span>
                  </div>
                ))}
            </div>

            <div className="lg:w-5/12 w-full px-3">
              <p className="py-2 lg:text-lg font-semibold">
                Popular Categories
              </p>

              <div className="grid grid-cols-3  gap-2">
                {popularCategories?.data?.unique_cat_list_data?.map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-col gap-2 cursor-pointer"
                    onClick={(event) => {
                      navigate("/all-products", {
                        state: {
                          from: "category",
                          category: item.id,
                        },
                      });
                      setOpen(false);
                      setClose(false);
                    }}
                  >
                    <img
                      alt=""
                      src={item.image}
                      className="w-16 h-16 rounded-md"
                    />
                    <p className="text-sm text-gray-500">{item.category}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default SearchPage;
